<template>
  <div class="flex">
    <template v-if="showAsList">
      <div class="flex w-full">
        <div class="w-1/2">
          <h2 v-text="'Roles:'" />
          <ul>
            <li
              v-for="role in allSelectedRoles"
              :key="role.id"
              v-text="role.attributes.title"
            />
          </ul>
        </div>
        <div class="w-1/2">
          <h2 v-text="'Abilities:'" />
          <ul>
            <li
              v-for="role in allSelectedAbilities"
              :key="role.id"
              v-text="role.attributes.title"
            />
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="w-1/4">
        <h3 v-text="'Roles'" />
        <ul class="list-reset ml-1">
          <li
            v-for="role in roles.data"
            :key="role.id"
          >
            <input
              :id="isDisabled ? `disabled_role_${role.id}` : `role_${role.id}`"
              :name="isDisabled ? `disabled_role_${role.id}` : `role_${role.id}`"
              :disabled="isDisabled"
              :aria-disabled="isDisabled"
              :checked="allRoleAbilitiesAreSelected(role)"
              :value="role.id"
              type="checkbox"
              @change="toggleRole(role)"
            >
            <label
              :for="isDisabled ? `disabled_role_${role.id}` : `role_${role.id}`"
              v-text="role.attributes.title"
            />
          </li>
        </ul>
      </div>
      <div class="w-3/4 mb-6">
        <h3 v-text="'Abilities'" />
        <input
          v-show="!isDisabled"
          v-model="query"
          placeholder="Filter abilities"
          style="margin-bottom: 0;"
          type="text"
        >
        <div
          class="flex overflow-y-scroll mt-4"
          style="max-height: 600px;"
        >
          <div class="w-1/3">
            <ul class="list-reset mt-0">
              <li
                v-for="role in roles.data.slice(0,2)"
                :key="role.id"
              >
                {{ role.attributes.title }}
                <ul class="list-reset ml-1 mb-6">
                  <li
                    v-for="ability in filteredRoleAbilities(role)"
                    :key="ability.id"
                  >
                    <input
                      :id="isDisabled ? `disabled_ability_${ability.id}` : `ability_${ability.id}`"
                      v-model="selectedAbilities"
                      :name="isDisabled ? `disabled_ability_${ability.id}` : `ability_${ability.id}`"
                      :disabled="isDisabled"
                      :aria-disabled="isDisabled"
                      :value="ability.id"
                      type="checkbox"
                    >
                    <label
                      :for="isDisabled ? `disabled_ability_${ability.id}` : `ability_${ability.id}`"
                      v-text="ability.attributes.title"
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="w-1/3">
            <ul class="list-reset mt-0">
              <li
                v-for="role in roles.data.slice(2, 3)"
                :key="role.id"
              >
                {{ role.attributes.title }}
                <ul class="list-reset ml-1 mb-6">
                  <li
                    v-for="ability in filteredRoleAbilities(role)"
                    :key="ability.id"
                  >
                    <input
                      :id="isDisabled ? `disabled_ability_${ability.id}` : `ability_${ability.id}`"
                      v-model="selectedAbilities"
                      :name="isDisabled ? `disabled_ability_${ability.id}` : `ability_${ability.id}`"
                      :disabled="isDisabled"
                      :aria-disabled="isDisabled"
                      :value="ability.id"
                      type="checkbox"
                    >
                    <label
                      :for="isDisabled ? `disabled_ability_${ability.id}` : `ability_${ability.id}`"
                      v-text="ability.attributes.title"
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="w-1/3">
            <ul class="list-reset mt-0">
              <li
                v-for="role in roles.data.slice(3, 10)"
                :key="role.id"
              >
                {{ role.attributes.title }}
                <ul class="list-reset ml-1 mb-6">
                  <li
                    v-for="ability in filteredRoleAbilities(role)"
                    :key="ability.id"
                  >
                    <input
                      :id="isDisabled ? `disabled_ability_${ability.id}` : `ability_${ability.id}`"
                      v-model="selectedAbilities"
                      :name="isDisabled ? `disabled_ability_${ability.id}` : `ability_${ability.id}`"
                      :disabled="isDisabled"
                      :aria-disabled="isDisabled"
                      :value="ability.id"
                      type="checkbox"
                    >
                    <label
                      :for="isDisabled ? `disabled_ability_${ability.id}` : `ability_${ability.id}`"
                      v-text="ability.attributes.title"
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'SelectPermissions',
  props: {
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    preSelected: {
      type: Object,
      required: false,
      default: () => ({
        role_ids: [],
        ability_ids: [],
      }),

    },
    showAsList: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      query: '',
      loading: false,
      roles: {
        data: [],
      },
      membershipAbilities: {
        data: [],
      },
      selectedRoles: this.preSelected.role_ids,
      selectedAbilities: this.preSelected.ability_ids,
    }
  },
  computed: {
    allSelectedRoles() {
      if (!this.roles.data.length) {
        return
      }

      return _.filter(this.roles.data, role => this.allRoleAbilitiesAreSelected(role))
    },
    allSelectedAbilities() {
      if (!this.roles.data.length || !this.preSelected.ability_ids) {
        return
      }

      const vm = this

      return _.filter(
        _.uniqBy(
          _.flatMap(this.roles.data, role => role.abilities.data),
          ability => ability.id
        ),
        ability => vm.preSelected.ability_ids.includes(ability.id)
      )
    },
  },
  watch: {
    selectedAbilities() {
      this.$emit('permissionSelected', {
        role_ids: this.selectedRoles,
        ability_ids: this.selectedAbilities,
      })
    },
    selectedRoles() {
      this.$emit('permissionSelected', {
        role_ids: this.selectedRoles,
        ability_ids: this.selectedAbilities,
      })
    },
    preSelected() {
      this.selectedAbilities = this.preSelected.ability_ids
      this.selectedRoles = this.preSelected.role_ids
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetch()
  },
  methods: {
    filteredRoleAbilities(role) {
      return role.abilities.data.filter((ability) => {
        return ability.attributes.title.toLowerCase().includes(this.query.toLowerCase())
      })
    },
    allRoleAbilitiesAreSelected(role) {
      const allRoleAbilitiesAreSelected = _.difference(_.map(role.abilities.data, 'id'), this.selectedAbilities).length === 0
      const index = this.selectedRoles ? this.selectedRoles.indexOf(role.id) : -1

      if (allRoleAbilitiesAreSelected) {
        if (index === -1) {
          this.selectedRoles.push(role.id)
        }
      } else {
        if (index > -1) {
          this.selectedRoles.splice(index, 1)
        }
      }

      return allRoleAbilitiesAreSelected
    },
    fetch() {
      this.$api.active().get('roles?include=abilities')
        .then((response) => {
          this.roles = response.data
        }).then(() => {
          if (this.membershipUuid) {
            this.$api.active().get(`memberships/${this.membershipUuid}/abilities`).then((response) => {
              this.membershipAbilities = response.data

              this.selectedAbilities = _.map(response.data.data, 'id')
            })
          }
        })
    },
    toggleRole(role) {
      const roleIndex = this.selectedRoles.indexOf(role.id)

      if (roleIndex === -1) {
        this.selectedRoles.push(role.id)

        role.abilities.data.forEach((ability) => {
          if (this.selectedAbilities.indexOf(ability.id) === -1) {
            this.selectedAbilities.push(ability.id)
          }
        })
      } else {
        this.selectedRoles.splice(roleIndex, 1)

        role.abilities.data.forEach((ability) => {
          const index = this.selectedAbilities.indexOf(ability.id)

          if (index > -1) {
            this.selectedAbilities.splice(index, 1)
          }
        })
      }
    },
  },
}
</script>
